
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { kpiBenchmarkData } from '@/data/benchmarkData';
import { getPerformanceIcon, getPerformanceBadge } from '@/utils/performanceUtils';

export const KpiBenchmarkTable = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Key Performance Indicators - Detailed Comparison</CardTitle>
        <p className="text-sm text-muted-foreground">
          Compare your company's performance with peer ranges and industry benchmarks
        </p>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Metric</TableHead>
              <TableHead>Your Performance</TableHead>
              <TableHead>Your Value</TableHead>
              <TableHead>Median (Peers)</TableHead>
              <TableHead>Your peers mainly fall between</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {kpiBenchmarkData.map((metric, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{metric.title}</TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    {getPerformanceIcon(metric.performance)}
                    {getPerformanceBadge(metric.performance)}
                  </div>
                </TableCell>
                <TableCell className="font-semibold">
                  {metric.yourValue}{metric.unit}
                </TableCell>
                <TableCell>
                  {metric.industryAverage}{metric.unit}
                </TableCell>
                <TableCell className="text-muted-foreground">
                  {metric.peerRangeMin}{metric.unit} - {metric.peerRangeMax}{metric.unit}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
